import { useEffect, useRef } from 'react';

type EscapeCloser = () => void;

const escapeClosers: EscapeCloser[] = [];

export const useEscapeToClose = (onClose: () => void, enabled = true) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const closer = () => {
      onCloseRef.current();
    };

    escapeClosers.push(closer);

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') {
        return;
      }

      if (escapeClosers[escapeClosers.length - 1] !== closer) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      closer();
    };

    document.addEventListener('keydown', handleKeyDown, true);

    return () => {
      document.removeEventListener('keydown', handleKeyDown, true);
      const closerIndex = escapeClosers.lastIndexOf(closer);

      if (closerIndex >= 0) {
        escapeClosers.splice(closerIndex, 1);
      }
    };
  }, [enabled]);
};
